export function bob2Position(
  theta1: number, theta2: number, l1: number, l2: number,
): { x: number; y: number } {
  const x1 = l1 * Math.sin(theta1);
  const y1 = -l1 * Math.cos(theta1);
  return { x: x1 + l2 * Math.sin(theta2), y: y1 - l2 * Math.cos(theta2) };
}

export function bob1Position(
  theta1: number, l1: number,
): { x: number; y: number } {
  return { x: l1 * Math.sin(theta1), y: -l1 * Math.cos(theta1) };
}

export type PositionFn = (state: number[]) => Array<{ x: number; y: number }>;

export function makePositionFn(
  system: 'rigid' | 'elastic12' | 'nonlinear',
  L1: number, L2: number,
): PositionFn {
  return (state) => {
    const t1 = state[0];
    const t2 = state[4];
    const l1 = system === 'rigid' ? L1 : L1 + state[2];
    const l2 = system === 'rigid' ? L2 : L2 + state[6];
    return [bob1Position(t1, l1), bob2Position(t1, t2, l1, l2)];
  };
}
